/* eslint-disable react/jsx-no-comment-textnodes */
import { Routes, Route } from "react-router-dom";
import KioskRoutes from "./kiosk/KioskRoutes";
import { NotFound } from "pages/common/privateComponents/notFound";
import { Suspense } from "react";
import { TaxiSplashScreen } from "pages/common/privateComponents/taxiSplashScreen/view";
// import marker
const Router = () => {
  return (
    <Suspense fallback={<TaxiSplashScreen />}>
      <Routes>
        {/* ------------------management -----------------------*/}
        <Route path="*" element={<NotFound />} />
        <Route path="/not-found" element={<NotFound />} />
        {/* ------------------kiosk-----------------------*/}
        <Route path="/kiosk/*" element={<KioskRoutes />} />
        // route marker
      </Routes>
    </Suspense>
  );
};

export default Router;
